let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8aLon")).then(() => parcelRequire('hpXeN'));